import { useEffect } from 'react'
import Link from 'components/Navigation/WrapperLink'
import styles from './ThankYou.module.scss'

export default function ThankYou({ isLoggedIn = true }) {
  /**
   * Scroll page to top when ThankYou is mounted.
   */
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={`container ${styles.section}`}>
      <header className={styles.header}>
        <h2 className={`gradient-text ${styles.title}`}>
          Hurraa! Kaikki on lähetetty
        </h2>
        <p>Tarjouspyyntösi ovat matkalla!🎉</p>
        <p>Palveluntarjoajat pyrkivät vastaamaan 24 tunnin sisällä.</p>
        <br />
        <p>Lähetämme sinulle vahvistuksen tarjouspyynnöistä sähköpostiisi.</p>

        {isLoggedIn && (
          <>
            Löydät ne myös{' '}
            <Link data={{ slug: '/oma-tili', type: '' }}>
              <span className={styles.link}>täältä</span>
            </Link>
          </>
        )}
      </header>

      <div className={styles.buttonWrap}>
        <Link data={{ slug: '/tapahtumat', type: 'event_archive' }}>
          <button className="btn btn--primary">Palaa hakuun</button>
        </Link>
        <Link data={{ slug: '/inspiraatiota-tapahtumaasi', type: '' }}>
          <button className="btn btn--green">Inspiroidu</button>
        </Link>
      </div>
    </div>
  )
}
